import {useWholesaler} from 'context/wholesaler';
import React from 'react';
import {useLocation, useNavigate, useMatch} from 'react-router-dom';

interface SearchedProductsProps {
  subProducts?: Array<Isubproducts>;
  products?: Array<IFarmProductsData>;
}
const SearchedProducts = ({subProducts, products}: SearchedProductsProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {wholesaler, updateSubProduct} = useWholesaler();
  const isFarmRoute = useMatch('/farm/add-ad/purchase');
  return (
    <div className="flex flex-col gap-4 overflow-y-auto max-h-[68vh] h-[83%] w-full pt-2">
      {products?.map((item, index) => {
        return (
          <button
            className="flex gap-2 items-center"
            key={index}
            onClick={() => {
              navigate(
                `${
                  isFarmRoute ? '/farm' : '/wholesaler'
                }/add-ad/purchase/products/${item.guid}`,
                {
                  state: {
                    title: item.title,
                  },
                },
              );
            }}
          >
            {item.icon && <span className={` text-primary  ${item.icon}`} />}
            <div className="text-gray-6 font-medium text-[15px] leading-[20px] ">
              {item.title}
            </div>
          </button>
        );
      })}
      <div className="w-full border-[1px] " />
      {subProducts?.map(item => (
        <button
          key={item.guid}
          className="text-gray-6 font-medium text-[15px] leading-[20px] w-full flex"
          onClick={() => {
            if (wholesaler?.appType === 'post') {
              navigate('/wholesaler/add-ad/info');
              updateSubProduct(item.guid);
            } else {
              navigate(location.pathname + '/info/' + item.guid, {
                state: {
                  title: item.title,
                },
              });
            }
          }}
        >
          {item.title}
        </button>
      ))}
    </div>
  );
};

export default SearchedProducts;
